<template>
    <span>
        <train-station-cell v-bind="{row, options, value: row.train}" />
        <template v-if="agency || name">
            <template v-if="agency">{{agency}}</template><template v-if="hasSeparator"> - </template><template v-if="name">{{name}}</template>
        </template>
    </span>
</template>

<script>
import mixin from '../mixin';
import { TrainStations } from '@components/CRUD/Table/Cells';
export default {
    mixins: [ mixin ],
    components: { TrainStationCell: TrainStations },

    computed: {
        agency: function () {
            return !!this.row.agency
                ? this.row.agency.name
                : false;
        },

        name: function () {
            return !!this.row.train
                ? this.row.train.name
                : false
        },

        hasSeparator: function () {
            return this.agency && this.name;
        }
    }
}
</script>
